import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class LPLIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getLPLAccountSearchResults(searchTerms, page) {
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.LPL_SEARCH)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importLPLAccountHoldings(postParams) {
        const url = this.urlsService.INTEGRATIONS.LPL_IMPORT_ACCOUNT_HOLDINGS;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    activateLPLIntegration() {
        const url = this.urlsService.INTEGRATIONS.LPL_ACTIVATE;
        return this.ajaxService.postJsonDataObserveBody(url, {});
    }
    getLPLIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.LPL_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
}
LPLIntegrationService.ɵfac = function LPLIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LPLIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
LPLIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LPLIntegrationService, factory: LPLIntegrationService.ɵfac, providedIn: 'root' });
